import i18n from 'modules/core/lib/i18n'

/**
 * Given an attribute returns the header localized for the import table
 * This method aims to avoid I18n interpolation
 * @see https://www.notion.so/factorialco/Code-Pain-568f3ee12e7446fd875c6c3294d2fd7b?p=cccebffa0f934305af9e0edc663788de
 */
const getFieldKey = (attribute: string) => {
  switch (attribute) {
    case 'annual_workdays_count':
      return i18n.t('contract_versions.navigator.changes.annual_workdays_count')
    case 'annual_working_time_distribution':
      return i18n.t('contract_versions.navigator.changes.annual_working_time_distribution')
    case 'bank_holiday_treatment':
      return i18n.t('contract_versions.navigator.changes.bank_holiday_treatment')
    case 'contract_hours':
      return i18n.t('contract_versions.navigator.changes.contract_hours')
    case 'contracts_de_contract_type_id':
    case 'contracts_es_contract_type_id':
    case 'contracts_pt_contract_type_id':
      return i18n.t('contract_versions.navigator.changes.contracts_es_contract_type_id')
    case 'contracts_es_agreement_code_id':
      return i18n.t('contract_versions.navigator.changes.es_agreement_code_id')
    case 'contracts_es_a3innuva_job_position_id':
      return i18n.t('contract_versions.navigator.changes.es_a3innuva_job_position_id')
    case 'contracts_es_classification_id':
      return i18n.t('contract_versions.navigator.changes.es_classification_id')
    case 'contracts_es_cno_occupation_id':
      return i18n.t('contract_versions.navigator.changes.es_cno_occupation_id')
    case 'contracts_es_contribution_type_id':
      return i18n.t('contract_versions.navigator.changes.es_contribution_type_id')
    case 'contracts_es_education_level_id':
      return i18n.t('contract_versions.navigator.changes.contracts_es_education_level_id')
    case 'contracts_es_occupation_code_id':
      return i18n.t('contract_versions.navigator.changes.es_occupation_code_id')
    case 'contracts_es_professional_category_id':
      return i18n.t('contract_versions.navigator.changes.contracts_es_professional_category_id')
    case 'contracts_es_regime_id':
      return i18n.t('contract_versions.navigator.changes.es_regime_id')
    case 'contracts_es_tariff_group_id':
      return i18n.t('contract_versions.navigator.changes.es_tariff_group_id')
    case 'contracts_es_working_day_type_id':
      return i18n.t('contract_versions.navigator.changes.contracts_es_working_day_type_id')
    case 'contracts_fr_contract_type_id':
      return i18n.t('contract_versions.navigator.changes.fr_contract_type_id')
    case 'contracts_fr_level_id':
      return i18n.t('contract_versions.navigator.changes.fr_level_id')
    case 'contracts_fr_mutual_id':
      return i18n.t('contract_versions.navigator.changes.fr_mutual_id')
    case 'contracts_fr_professional_category_id':
      return i18n.t('contract_versions.navigator.changes.fr_professional_category_id')
    case 'contracts_fr_step_id':
      return i18n.t('contract_versions.navigator.changes.fr_step_id')
    case 'contracts_fr_work_type_id':
      return i18n.t('contract_versions.navigator.changes.fr_work_type_id')
    case 'country':
      return i18n.t('contract_versions.navigator.changes.country')
    case 'de_activity_type':
      return i18n.t('contract_versions.navigator.changes.de_activity_type')
    case 'de_contract_type_id':
      return i18n.t('contract_versions.navigator.changes.de_contract_type_id')
    case 'de_employment_type':
      return i18n.t('contract_versions.navigator.changes.de_employment_type')
    case 'de_flat_rate_tax':
      return i18n.t('contract_versions.navigator.changes.de_flat_rate_tax')
    case 'de_personal_key_group_id':
      return i18n.t('contract_versions.navigator.changes.de_personal_key_group_id')
    case 'deleted_additional_compensation':
      return i18n.t('contract_versions.navigator.changes.deleted_additional_compensation')
    case 'deleted_custom_field':
      return i18n.t('contract_versions.navigator.changes.deleted_custom_field')
    case 'effective_on':
      return i18n.t('contract_versions.navigator.changes.effective_on')
    case 'de_base_salary_type_id':
      return i18n.t('contract_versions.navigator.changes.de_base_salary_type_id')
    case 'ends_on':
      return i18n.t('contract_versions.navigator.changes.ends_on')
    case 'es_contract_observations':
      return i18n.t('contract_versions.navigator.changes.es_contract_observations')
    case 'es_contract_type_id':
      return i18n.t('contract_versions.navigator.changes.es_contract_type_id')
    case 'es_cotization_group':
      return i18n.t('contract_versions.navigator.changes.es_cotization_group')
    case 'es_education_level_id':
      return i18n.t('contract_versions.navigator.changes.es_education_level_id')
    case 'es_has_teleworking_contract':
      return i18n.t('contract_versions.navigator.changes.es_has_teleworking_contract')
    case 'es_job_description':
      return i18n.t('contract_versions.navigator.changes.es_job_description')
    case 'es_professional_category_id':
      return i18n.t('contract_versions.navigator.changes.es_professional_category_id')
    case 'es_tariff_group_name':
      return i18n.t('contract_versions.navigator.changes.es_tariff_group')
    case 'es_working_day_type_id':
      return i18n.t('contract_versions.navigator.changes.es_working_day_type_id')
    case 'fr_coefficient':
      return i18n.t('contract_versions.navigator.changes.fr_coefficient')
    case 'fr_employee_type':
      return i18n.t('contract_versions.navigator.changes.fr_employee_type')
    case 'fr_forfait_jours':
      return i18n.t('contract_versions.navigator.changes.fr_forfait_jours')
    case 'fr_jours_par_an':
    case 'fr_jours_par_an_cents':
      return i18n.t('contract_versions.navigator.changes.fr_jours_par_an')
    case 'gross_salary':
      return i18n.t('contract_versions.navigator.changes.gross_salary')
    case 'base_salary':
      return i18n.t('contract_versions.navigator.changes.base_salary')
    case 'has_payroll':
      return i18n.t('contract_versions.navigator.changes.has_payroll')
    case 'has_trial_period':
      return i18n.t('contract_versions.navigator.changes.has_trial_period')
    case 'job_catalog_level':
    case 'job_catalog_level_id':
      return i18n.t('contract_versions.navigator.changes.job_catalog_level_id')
    case 'job_catalog_role':
      return i18n.t('contract_versions.navigator.changes.job_catalog_role')
    case 'job_catalog_tree_node_uuid':
      return i18n.t('contract_versions.navigator.changes.job_catalog_tree_node_uuid')
    case 'job_title':
      return i18n.t('contract_versions.navigator.changes.job_title')
    case 'max_legal_yearly_hours':
      return i18n.t('contract_versions.navigator.changes.max_legal_yearly_hours')
    case 'max_work_days_in_row':
      return i18n.t('contract_versions.flows.fix.steps.work_hours.max_work_days_in_row.label')
    case 'max_work_minutes_per_day':
      return i18n.t('contract_versions.flows.fix.steps.work_hours.max_work_minutes_per_day.label')
    case 'maximum_weekly_hours':
      return i18n.t('contract_versions.navigator.changes.maximum_weekly_hours')
    case 'min_rest_hours_in_row':
      return i18n.t('contract_versions.flows.fix.steps.work_hours.min_rest_hours_in_row.label')
    case 'min_rest_minutes_between_days':
      return i18n.t(
        'contract_versions.flows.fix.steps.work_hours.min_rest_minutes_between_days.label'
      )
    case 'new_additional_compensation':
      return i18n.t('contract_versions.navigator.changes.new_additional_compensation')
    case 'new_custom_field':
      return i18n.t('contract_versions.navigator.changes.new_custom_field')
    case 'payroll_policy':
      return i18n.t('contract_versions.navigator.changes.payroll_policy')
    case 'pt_contract_type_id':
      return i18n.t('contract_versions.navigator.changes.pt_contract_type_id')
    case 'salary_amount':
      return i18n.t('contract_versions.navigator.changes.gross_salary')
    case 'salary_frequency':
      return i18n.t('contract_versions.navigator.changes.salary_frequency')
    case 'starts_on':
      return i18n.t('contract_versions.navigator.changes.starts_on')
    case 'trial_period_ends_on':
      return i18n.t('contract_versions.navigator.changes.trial_period_ends_on')
    case 'type':
      return i18n.t('contract_versions.navigator.changes.type')
    case 'working_hours':
      return i18n.t('contract_versions.navigator.changes.contract_hours')
    case 'working_time_percentage_in_cents':
      return i18n.t('contract_versions.navigator.changes.working_time_percentage')
    case 'working_week_days':
      return i18n.t('contract_versions.navigator.changes.working_week_days')
    default:
      return attribute
  }
}

export default getFieldKey
